export var buildEnv = {
    buildMode: 'release',
    sdkVersion: '4.0.1',
};
//# sourceMappingURL=buildEnv.js.map